<template>
  <img :src="logo" style="width: 70%" @click="router.push('/')"/>
</template>

<script setup lang="ts">

import logo from './company-logo.png'
import router from "@/router";


</script>

<style scoped>

img {
  padding-top: 15px;
  padding-bottom: 15px;
}

img:hover {
  cursor: pointer;
}
</style>
